// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2IsFG","bigColWidth":"Table_bigColWidth__8lKX0","biggerColWidth":"Table_biggerColWidth__1FjNo","row":"Table_row__J2ROG","col":"Table_col__skhoA"};